module.exports = __webpack_public_path__ + "static/media/wc.41f51515.jpg";